export const blockIconsHardwareVideogameAsset = (
	<span className='material-symbols-outlined'>videogame_asset</span>
);
